const bulks = {
  10100: [
    {
      side: 'top',
      flats: [
        865, 881, 897, 913, 929, 945, 961, 866, 882, 898, 914, 930, 946, 962, 867, 883, 899, 915, 931, 947, 963, 868,
        884, 900, 916, 932, 948, 964, 869, 885, 901, 917, 933, 949, 965, 977, 993, 1009, 1024, 1039, 1054, 1069, 978,
        994, 1010, 1025, 1040, 1055, 1070, 979, 995, 1011, 1026, 1041, 1056, 1071, 980, 996, 1012, 1027, 1042, 1057,
        1072, 981, 997, 1084, 1099, 1114, 1129, 1144, 1159, 1174, 1085, 1100, 1115, 1130, 1145, 1160, 1175, 1086, 1101,
        1116, 1131, 1146, 1161, 1176, 1087, 1102, 1117, 1132, 1147, 1162, 1177, 1189, 1203, 1217, 1231, 1245, 1258,
        1271, 1190, 1204, 1218, 1232, 1246, 1259, 1272, 1191, 1205, 1219, 1233, 1247, 1260, 1273, 1192, 1206, 1220,
        1234, 1248, 1261, 1274, 1284, 1297, 1310, 1320, 1326, 1285, 1298, 1311, 1321, 1286, 1299, 1312, 1287, 1300,
        1313,
      ],
    },
    {
      side: 'topRight',
      flats: [
        970, 1013, 1207, 1262, 886, 1028, 1221, 1275, 802, 1043, 1235, 1288, 718, 1058, 1249, 1301, 634, 1073, 1314,
        550, 1088, 466, 1103, 382, 1118, 298, 1133, 1148, 1163, 1178, 1193,
      ],
    },
    {
      side: 'right',
      flats: [1315],
    },
    {
      side: 'bottomRight',
      flats: [
        855, 999, 1194, 1250, 871, 1014, 1208, 1263, 887, 1029, 1222, 1276, 903, 1044, 1236, 1289, 919, 1059, 1302, 935,
        1074, 951, 1089, 967, 1104, 983, 1119, 1134, 1149, 1164, 1179,
      ],
    },
    {
      side: 'bottom',
      flats: [
        856, 872, 888, 904, 920, 936, 952, 857, 873, 889, 905, 921, 937, 953, 858, 874, 890, 906, 922, 938, 954, 859,
        875, 891, 907, 923, 939, 955, 860, 876, 892, 908, 924, 940, 956, 861, 877, 893, 909, 925, 941, 957, 968, 984,
        1000, 1015, 1030, 1045, 1060, 969, 985, 1001, 1016, 1031, 1046, 1061, 970, 986, 1002, 1017, 1032, 1047, 1062,
        971, 987, 1003, 1018, 1033, 1048, 1063, 972, 988, 1004, 1019, 1034, 1049, 1064, 973, 989, 1005, 1020, 1035,
        1050, 1065, 1075, 1090, 1105, 1120, 1135, 1150, 1165, 1076, 1091, 1106, 1121, 1136, 1151, 1166, 1077, 1092,
        1107, 1122, 1137, 1152, 1167, 1078, 1093, 1108, 1123, 1138, 1153, 1168, 1079, 1094, 1109, 1124, 1139, 1154,
        1169, 1080, 1095, 1110, 1125, 1140, 1155, 1170, 1180, 1195, 1209, 1223, 1237, 1251, 1264, 1181, 1196, 1210,
        1224, 1238, 1252, 1265, 1182, 1197, 1211, 1225, 1239, 1253, 1266, 1183, 1198, 1212, 1226, 1240, 1254, 1267,
        1184, 1199, 1213, 1227, 1241, 1185, 1277, 1290, 1303, 1316, 1322, 1278, 1291, 1304, 1317, 1323, 1279, 1292,
        1305, 1280, 1293, 1306,
      ],
    },
    {
      side: 'bottomLeft',
      flats: [
        862, 1006, 1200, 1255, 1318, 1324, 878, 1021, 1214, 1268, 894, 1036, 1228, 1281, 910, 1051, 1242, 1294, 926,
        1066, 1307, 942, 1081, 958, 1096, 974, 1111, 990, 1126, 1141, 1156, 1171, 1186,
      ],
    },
    {
      side: 'left',
      flats: [
        863, 1007, 1201, 1256, 879, 1022, 1215, 1269, 895, 1037, 1229, 1282, 911, 1052, 1243, 1295, 927, 1067, 1308,
        943, 1082, 959, 1097, 975, 1112, 991, 1127, 1142, 1157, 1172, 1187,
      ],
    },
    {
      side: 'topLeft',
      flats: [
        864, 1008, 1202, 1257, 1319, 1325, 880, 1023, 1216, 1270, 896, 1038, 1230, 1283, 912, 1053, 1244, 1296, 928,
        1068, 1309, 944, 1083, 960, 1098, 976, 1113, 992, 1128, 1143, 1158, 1173, 1188,
      ],
    },
  ],
  9758: [
    {
      side: 'top',
      flats: [
        10, 25, 40, 55, 70, 85, 100, 11, 26, 41, 56, 71, 86, 101, 12, 27, 42, 57, 72, 87, 102, 13, 28, 43, 58, 73, 88,
        103, 14, 29, 44, 59, 74, 89, 104, 115, 130, 145, 158, 170, 182, 194, 116, 131, 146, 159, 171, 183, 195, 117,
        132, 147, 160, 172, 184, 196, 118, 133, 148, 161, 173, 185, 197, 119, 134, 149, 206, 218, 230, 242, 254, 266,
        278, 207, 219, 231, 243, 255, 267, 279, 208, 220, 232, 244, 256, 268, 280, 209, 221, 233, 245, 257, 269, 281,
        290, 302, 314, 326, 338, 350, 361, 291, 303, 315, 327, 339, 351, 362, 292, 304, 316, 328, 340, 352, 367, 293,
        305, 317, 329, 341, 353,
      ],
    },
    {
      side: 'topRight',
      flats: [
        15, 246, 30, 258, 45, 270, 60, 282, 75, 294, 90, 306, 105, 318, 120, 330, 135, 342, 150, 354, 162, 174, 186,
        198, 210, 222, 234,
      ],
    },
    {
      side: 'right',
      flats: [355],
    },
    {
      side: 'bottomRight',
      flats: [
        1, 235, 16, 247, 31, 259, 46, 271, 61, 283, 76, 295, 91, 307, 106, 319, 121, 331, 136, 343, 151, 163, 175, 187,
        199, 211, 223,
      ],
    },
    {
      side: 'bottom',
      flats: [
        2, 17, 32, 47, 62, 77, 92, 3, 18, 33, 48, 63, 78, 93, 4, 19, 34, 49, 64, 79, 94, 5, 20, 35, 50, 65, 80, 95, 6,
        21, 36, 51, 66, 81, 96, 107, 122, 137, 152, 164, 176, 188, 108, 123, 138, 153, 165, 177, 189, 109, 124, 139,
        154, 166, 178, 190, 110, 125, 140, 155, 167, 179, 191, 111, 126, 141, 200, 212, 224, 236, 248, 260, 272, 201,
        213, 225, 237, 249, 261, 273, 202, 214, 226, 238, 250, 262, 274, 203, 215, 227, 239, 251, 263, 275, 284, 296,
        308, 320, 332, 344, 356, 285, 297, 309, 321, 333, 345, 357, 286, 298, 310, 322, 334, 346, 358, 287, 299, 311,
        323, 335, 347, 363, 364,
      ],
    },
    {
      side: 'bottomLeft',
      flats: [
        7, 240, 22, 252, 37, 264, 52, 276, 67, 288, 82, 300, 97, 312, 112, 324, 127, 336, 142, 348, 156, 359, 168, 365,
        180, 192, 204, 216, 228,
      ],
    },
    {
      side: 'left',
      flats: [8, 23, 38, 53, 68, 83, 98, 113, 128, 143],
    },
    {
      side: 'topLeft',
      flats: [
        9, 241, 24, 253, 39, 265, 54, 277, 69, 289, 84, 301, 99, 313, 114, 325, 129, 337, 144, 349, 157, 360, 169, 366,
        181, 193, 205, 217, 229,
      ],
    },
  ],
  9335: [
    {
      side: 'top',
      flats: [
        2, 15, 28, 41, 54, 67, 80, 3, 16, 29, 42, 55, 68, 81, 4, 17, 30, 43, 56, 69, 82, 5, 18, 31, 44, 57, 70, 83, 93,
        106, 118, 130, 142, 154, 166, 94, 107, 119, 131, 143, 155, 167, 95, 108, 120, 132, 144, 156, 168, 96, 109, 121,
        133, 145, 157, 169, 178, 190, 202, 214, 224, 234, 244, 179, 191, 203, 215, 225, 235, 245, 180, 192, 204, 216,
        226, 236, 246, 181, 193, 205, 254, 264, 274, 284, 294, 304, 314, 255, 265, 275, 285, 295, 305, 315, 256, 266,
        276, 286, 296, 306, 316, 324, 325,
      ],
    },
    {
      side: 'topRight',
      flats: [
        6, 217, 19, 227, 32, 237, 45, 247, 58, 257, 71, 267, 84, 277, 97, 287, 110, 297, 122, 307, 134, 317, 146, 326,
        158, 170, 182, 194, 206,
      ],
    },
    {
      side: 'right',
      flats: [],
    },
    {
      side: 'bottomRight',
      flats: [
        7, 218, 20, 228, 33, 238, 46, 248, 59, 258, 72, 268, 85, 278, 98, 288, 111, 298, 123, 308, 135, 318, 147, 327,
        159, 171, 183, 195, 207,
      ],
    },
    {
      side: 'bottom',
      flats: [
        8, 21, 34, 47, 60, 73, 86, 9, 22, 35, 48, 61, 74, 87, 10, 23, 36, 49, 62, 75, 88, 11, 24, 37, 50, 63, 76, 89,
        12, 25, 38, 51, 64, 77, 90, 99, 112, 124, 136, 148, 160, 172, 100, 113, 125, 137, 149, 161, 173, 101, 114, 126,
        138, 150, 162, 174, 102, 115, 127, 139, 151, 163, 175, 103, 184, 196, 208, 219, 229, 239, 249, 185, 197, 209,
        220, 230, 240, 250, 186, 198, 210, 221, 231, 241, 251, 187, 199, 211, 259, 269, 279, 289, 299, 309, 319, 260,
        270, 280, 290, 300, 310, 320, 261, 271, 281, 291, 301, 311, 321, 328, 329,
      ],
    },
    {
      side: 'bottomLeft',
      flats: [
        13, 222, 26, 232, 39, 242, 52, 252, 65, 262, 78, 272, 91, 282, 104, 292, 116, 302, 128, 312, 140, 322, 152, 330,
        164, 176, 188, 200, 212,
      ],
    },
    {
      side: 'left',
      flats: [],
    },
    {
      side: 'topLeft',
      flats: [
        1, 213, 14, 223, 27, 233, 40, 243, 53, 253, 66, 263, 79, 273, 92, 283, 105, 293, 117, 303, 129, 313, 141, 323,
        153, 165, 177, 189, 201,
      ],
    },
  ],
  10099: [
    {
      side: 'top',
      flats: [
        377, 392, 407, 422, 437, 452, 467, 378, 393, 408, 423, 438, 453, 468, 379, 394, 409, 424, 439, 454, 469, 380,
        395, 410, 425, 440, 455, 470, 381, 396, 411, 426, 441, 456, 471, 482, 497, 512, 527, 542, 557, 570, 483, 498,
        513, 528, 543, 558, 571, 484, 499, 514, 529, 544, 559, 572, 485, 500, 515, 530, 545, 560, 573, 486, 501, 516,
        531, 546, 561, 574, 583, 596, 609, 622, 634, 646, 658, 584, 597, 610, 623, 635, 647, 659, 585, 598, 611, 624,
        636, 648, 660, 586, 599, 612, 625, 637, 649, 661, 587, 600, 613, 670, 682, 694, 706, 718, 730, 742, 671, 683,
        695, 707, 719, 731, 743, 672, 684, 696, 708, 720, 732, 744, 673, 685, 697, 709, 721, 733, 745, 754, 766, 778,
        790, 801, 811, 821, 755, 767, 779, 791, 802, 812, 822, 756, 768, 780, 792, 803, 813, 833, 757, 769, 781, 793,
        831, 840, 848, 854, 832, 841, 849, 833,
      ],
    },
    {
      side: 'topRight',
      flats: [
        382, 804, 397, 814, 412, 824, 427, 834, 442, 842, 457, 472, 487, 502, 517, 532, 547, 562, 575, 588, 601, 614,
        626, 638, 650, 662, 674, 686, 698, 710, 722, 734, 746, 758, 770, 782, 794,
      ],
    },
    {
      side: 'right',
      flats: [843],
    },
    {
      side: 'bottomRight',
      flats: [
        368, 651, 383, 663, 398, 675, 413, 687, 428, 699, 443, 711, 458, 723, 473, 735, 488, 747, 503, 759, 518, 771,
        533, 783, 548, 795, 563, 805, 576, 815, 589, 825, 602, 835, 615, 627, 639,
      ],
    },
    {
      side: 'bottom',
      flats: [
        369, 384, 399, 414, 429, 444, 459, 370, 385, 400, 415, 430, 445, 460, 371, 386, 401, 416, 431, 446, 461, 372,
        387, 402, 417, 432, 447, 462, 373, 388, 403, 418, 433, 448, 463, 474, 489, 504, 519, 534, 549, 564, 475, 490,
        505, 520, 535, 550, 565, 476, 491, 506, 521, 536, 551, 566, 477, 492, 507, 522, 537, 552, 567, 478, 493, 508,
        523, 538, 553, 577, 590, 603, 616, 628, 640, 652, 578, 591, 604, 617, 629, 641, 653, 579, 592, 605, 618, 630,
        642, 654, 580, 593, 606, 619, 631, 643, 655, 664, 676, 688, 700, 712, 724, 736, 665, 677, 689, 701, 713, 725,
        737, 666, 678, 690, 702, 714, 726, 738, 667, 679, 691, 703, 715, 727, 739, 748, 760, 772, 784, 796, 806, 816,
        749, 761, 773, 785, 797, 807, 817, 450, 762, 774, 786, 798, 808, 818, 751, 763, 775, 787, 826, 836, 844, 850,
        827, 837, 845, 851, 828,
      ],
    },
    {
      side: 'bottomLeft',
      flats: [
        374, 799, 389, 809, 404, 819, 419, 829, 434, 838, 449, 846, 464, 852, 479, 494, 509, 524, 539, 554, 568, 581,
        594, 607, 620, 632, 644, 656, 668, 680, 692, 704, 716, 728, 740, 752, 764, 776, 788,
      ],
    },
    {
      side: 'left',
      flats: [375, 390, 405, 420, 435, 450, 465, 480, 495, 510, 525, 540, 555],
    },
    {
      side: 'topLeft',
      flats: [
        376, 800, 391, 810, 406, 820, 421, 830, 436, 839, 451, 847, 466, 853, 481, 496, 511, 526, 541, 556, 569, 582,
        595, 608, 621, 633, 645, 657, 669, 681, 693, 705, 717, 729, 741, 753, 765, 777, 789,
      ],
    },
  ],
};

export const getFlatPin = (bulkNumber, flatNumber) => {
  if (bulks[bulkNumber]) {
    const bulk = bulks[bulkNumber];

    let pinSide;

    bulk.map(item => {
      if (item.flats.includes(flatNumber)) {
        pinSide = item.side;
      }
      return null;
    });

    return pinSide;
  }

  return null;
};
